import { Box, Theme, styled } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';

export const hovered = (theme: Theme) => ({
  background: `${theme.palette.primary.main}10`,
  borderColor: theme.palette.primary.main,
});

export const UploadArea = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  border: `1px dashed ${theme.palette.divider}`,
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  transition: 'ease-out .3s',
  cursor: 'pointer',
  textAlign: 'center',
  '&:hover': {
    ...hovered(theme),
  },
}));

export const PatientTestReportDateTimePicker = styled(DateTimePicker)(({ theme }) => ({
  width: '100%',
}));
